var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/users/new"
    }
  }, [_c('a-button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    }
  }, [_c('i', {
    staticClass: "fe fe-user-plus font-size-15",
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Add user"
    }
  }), _vm._v(" New user ")])], 1), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('a-table', {
    attrs: {
      "columns": _vm.columns,
      "data-source": _vm.dataSource,
      "pagination": {
        pageSize: 50
      },
      "row-key": function rowKey(record) {
        return record.id;
      }
    },
    scopedSlots: _vm._u([{
      key: "participantAndVatCode",
      fn: function fn(text, record) {
        return _c('span', {}, [record.participant ? _c('span', [_vm._v(" " + _vm._s(record.participant.name) + " ( " + _vm._s(record.participant.vatCode) + " ) ")]) : _c('span', [_c('a-tag', {
          attrs: {
            "color": 'volcano'
          }
        }, [_vm._v("Unassigned")])], 1)]);
      }
    }, {
      key: "lastLogin",
      fn: function fn(text, record) {
        return _c('span', {}, [_c('a-tag', {
          attrs: {
            "color": record.lastOnlineAt === null ? 'volcano' : 'green'
          }
        }, [_vm._v(" " + _vm._s(record.lastOnlineAt === null ? 'Never' : record.lastOnlineBefore) + " ")]), _c('br'), _vm._v(" " + _vm._s(record.lastOnlineAt === null ? '' : "Last active at: ".concat(record.lastOnlineAt)) + " ")], 1);
      }
    }, {
      key: "actions",
      fn: function fn(record) {
        return _c('span', {}, [_c('a-popconfirm', {
          attrs: {
            "title": "Are you sure you want to delete this user?",
            "ok-text": "Yes",
            "cancel-text": "No"
          },
          on: {
            "confirm": function confirm($event) {
              return _vm.deleteUser(record.id);
            }
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-user-x align-middle text-danger",
          attrs: {
            "title": "Delete user"
          }
        })])]), _c('router-link', {
          attrs: {
            "to": "/users/edit/".concat(record.id)
          }
        }, [_c('a', [_c('i', {
          staticClass: "fe fe-edit align-middle text-gray-6",
          staticStyle: {
            "margin-left": "10px"
          },
          attrs: {
            "title": "Edit user"
          }
        })])])], 1);
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }